var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NewFile',{attrs:{"boxHeight":_vm.boxHeight,"multiple":"false","message":"Drop file or click to browse","accepted":_vm.allowedFileTypes,"fileNameSuffix":_vm.suffix,"basePath":_vm.basePath},on:{"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }